module.exports = __webpack_public_path__ + "static/media/drake.429eb5cd.jpg";